import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const InputField: React.FC<FieldComponentProps> = ({ field, name, disabled, countries }) => {
  const { control, getValues } = useFormContext()
  const required = !disabled && Boolean(field.fieldRequired)

  const isMobileField = field.slug === 'mobile_number'
  
  if(isMobileField) {
    const countryPrefixId = Number(getValues(`${name}.value2`))
    const country = countries?.find(country => Number(country.id) === countryPrefixId)
    const value = `${country?.phoneCode} ${getValues(`${name}.value`)}`
    return <FormFields.Input
      name={`${name}.value`}
      control={control}
      value={value}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      rules={required ? { required: true } : {}}
    />
  }

  return (
    <FormFields.Input
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      rules={required ? { required: true } : {}}
    />
  )
}

export default InputField
